import curry from 'lodash/curry';
import { css, FlattenSimpleInterpolation } from 'styled-components';

import IThemeInterface from '../../Theme/common';

import { normalizeColor } from './normalizeColor';

export type VALID_OUTLINE_STYLES =
  | 'auto'
  | 'dotted'
  | 'dashed'
  | 'dotted'
  | 'double'
  | 'groove'
  | 'ridge'
  | 'inset'
  | 'outset'
  | 'hidden'
  | 'solid';

export interface IOutlineStyleData {
  color?: string;
  size?: string;
  style?: VALID_OUTLINE_STYLES;
  offset?: string;
}

export type VALID_OUTLINE_DATA = IOutlineStyleData | string;

export const calcOutlineStyles = curry((
  theme: IThemeInterface,
  data: VALID_OUTLINE_DATA,
): FlattenSimpleInterpolation => {
  let color = normalizeColor(theme, theme.global.outline.color);
  let size = theme.global.outline.size;
  let style = theme.global.outline.style;
  let offset = '0';

  if (typeof data === 'string') {
    return css`
      outline: ${data};
    `;
  } else {
    color = data.color ? normalizeColor(theme, data.color) : color;
    size = data.size ? data.size : size;
    style = data.style ? data.style : style;
    offset = data.offset ? data.offset : offset;
  }

  const value = `${theme.global.edgeSize[size] || size} ${style} ${color}`;

  return css`
    outline: ${value};
    outline-offset: ${theme.global.edgeSize[offset] || offset};
  `;
});
